import { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import styles from './CommoditiesTemplate.module.css';
import cn from 'classnames';
import { Label, ListItem } from '../../atoms';
import { Button, Container } from 'react-bootstrap';
import { ListView } from '../../molecules';

interface ListViewContent {
  key: string;
  value: string | null;
}
interface ListViewData {
  imageUrl: string | null;
  content: ListViewContent[];
  id: string;
}

export interface CommoditiesTemplateProps {
  data: ListViewData[];
  onAddCommodityClick: () => void;
  onDeleteClick: (id: string) => void;
  onEditClick: (id: string) => void;
}

const CommoditiesTemplate: FC<CommoditiesTemplateProps> = ({
  data,
  onAddCommodityClick,
  onDeleteClick,
  onEditClick,
}) => {
  return (
    <BaseTemplate>
      <Container>
        <div className={cn(styles.heading)}>
          <Label content="Commodities" size="lg" />
          <Button variant="dark" onClick={onAddCommodityClick}>
            Add Commodity
          </Button>
        </div>
        <ListView>
          {data.map((item: ListViewData) => (
            <ListItem
              imageUrl={item.imageUrl}
              content={item.content}
              id={item.id}
              key={item.id}
              onDeleteClick={onDeleteClick}
              onEditClick={onEditClick}
            />
          ))}
        </ListView>
      </Container>
    </BaseTemplate>
  );
};

export default CommoditiesTemplate;
